// need refactor
(function () {
    const ecommerceAccessibility = {
        $toggle: '.cart-expand',
        toggleParent: '.add-to-cart.superDemo',
        commerceBox: '.checkoutProcessRightCol',
        init: function () {
            ecommerceAccessibility.control();
        },
        control: function () {
            $(ecommerceAccessibility.commerceBox)
                .find(ecommerceAccessibility.toggleParent)
                .on('keypress', function (e) {
                    if (e.which === 13) {
                        $(e.target).find(ecommerceAccessibility.$toggle).click();
                    }
                });
        },
    };

    UX.ecommerceAccessibility = ecommerceAccessibility; // add to global namespace
})();
